import { apiSlice } from '@/core/api/apiSlice';
import { ApiResponse } from '@/types/common.types';
import {
  AdminProfile,
  CopilotSettingsRequest,
  InviteAdminRequest,
  UpdatePlanRequest,
  RemoveMemberRequest,
  TourStatusRequest,
  UpdateProfileRequest,
} from '@/types/admin.types';

export const adminApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAdmins: builder.query<ApiResponse<AdminProfile[]>, void>({
            query: () => '/admins',
        }),
        adminInvite: builder.mutation<ApiResponse<any>, InviteAdminRequest>({
            query: (inviteData) => ({
                url: '/admins/invite',
                method: 'POST',
                body: inviteData,
            }),
        }),
        removeAdmin: builder.mutation<ApiResponse<any>, string>({
            query: (id) => ({
                url: `/admins/${id}`,
                method: 'DELETE',
            }),
        }),
        updateAdminPlan: builder.mutation<ApiResponse<any>, UpdatePlanRequest>({
            query: (planData) => ({
                url: '/admins/plan',
                method: 'PUT',
                body: planData,
            }),
        }),
        updateCopilotSettings: builder.mutation<ApiResponse<any>, CopilotSettingsRequest>({
            query: (settingsData) => ({
                url: '/admins/me/copilot-settings',
                method: 'PUT',
                body: settingsData,
            }),
        }),
        updateTourStatus: builder.mutation<ApiResponse<any>, TourStatusRequest>({
            query: (tourData) => ({
                url: '/admins/me/tour',
                method: 'PUT',
                body: tourData,
            }),
        }),
        updateProfile: builder.mutation<ApiResponse<any>, UpdateProfileRequest>({
            query: (profileData) => ({
                url: '/admins/me',
                method: 'PUT',
                body: profileData,
            }),
        }),
        getMe: builder.query<ApiResponse<AdminProfile>, void>({
            query: () => '/admins/me',
        }),
    }),
});

export const {
    useGetAdminsQuery,
    useAdminInviteMutation,
    useRemoveAdminMutation,
    useUpdateAdminPlanMutation,
    useUpdateCopilotSettingsMutation,
    useUpdateTourStatusMutation,
    useUpdateProfileMutation,
    useGetMeQuery,
} = adminApi;
